<div 
  class="ss-r-button" 
  [ngClass]="{'with-shadow': shadow}"
  [style.width]="size" 
  [style.height]="size" 
  [style.backgroundColor]="color"
  [ngStyle]="{'border': border ? '1px solid ' + border : 'none'}"
>
  <ng-content></ng-content>
</div>